import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  if (typeof document !== "undefined") document.title = "Page not found — School Smiles Australia";
  return (
    <section className="container-page py-24 text-center" data-testid="not-found">
      <div className="font-display font-extrabold text-7xl md:text-9xl text-[#1677C8]/20">404</div>
      <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl text-[#14324A]">We couldn't find that page</h1>
      <p className="mt-3 text-[#4B6B86]">The page may have been moved or removed. Let's get you back on track.</p>
      <Link to="/" className="btn-primary mt-8 inline-flex">
        <ArrowLeft size={18} strokeWidth={2.5}/> Back to home
      </Link>
    </section>
  );
};

export default NotFound;
